<template>
  <div class="container-fluid">
    <div id="next">
      <div class="row wrapper">
        <div class="col-12 col-md-8 ">
          <div class="main next-steps">
            <div class="company-logo mb-4"></div>
            <h1>Next steps</h1>
            <div v-html="pageContent.pages.next.leftBlock"></div>
          </div>
        </div>
        <div class="col-12 col-md-4 right-sidebar-wrapper">
          <div class="right-sidebar">
            <div v-html="pageContent.pages.next.rightBlock"></div>
          </div>
        </div>

      </div>
    </div>
    <CustomFooter></CustomFooter>
  </div>

</template>

<style>
</style>

<script>
import { mapGetters } from 'vuex';
import CustomFooter from '../components/CustomFooter';

export default {
  name: 'Next',
  components: {CustomFooter},
  computed: {
    ...mapGetters(["pageContent"]),
  },
  methods: {
    clickCTA(e) {
      this.$gtag.event('click-cta', { event_category: 'cta', event_label: e.currentTarget.href });
    },
    startOver() {
      this.$store.commit("setDefaultData");
    }
  },
  mounted() {
    // add click functions to any CTA links on page
    var ctaList = document.querySelectorAll('.cta');
    // console.log(ctaList);
    ctaList.forEach(link => {
      link.addEventListener('click', this.clickCTA)
    });

    // add click function for start over button
    var startOverBtn = document.querySelector('.start-over');
    startOverBtn.addEventListener('click', this.startOver);
    this.$refreshIframeHeight();
    this.$scrollIframeTop();
    window.addEventListener("resize", this.$refreshIframeHeight);
  },
  destroyed() {
    window.removeEventListener("resize", this.$refreshIframeHeight);
  }
}


</script>
